import { occupationEntityName } from '../../../../backend/config/classifiers/entities/entityTypes';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { getAccountsManageFilter } from '@juvare/contact-management/backend/features/permissions/shared';
export function mapLicenseCheckLatestStatusFilter(userState, filterData, expiringOnlyFilter, accountFilter) {
    const filter = [];
    filter.push({
        column: 'personId',
        op: 'in',
        subFilter: {
            entity: accountEntityName,
            filter: [
                ...(accountFilter !== null && accountFilter !== void 0 ? accountFilter : []),
                {
                    column: 'systemStatus',
                    op: '=',
                    value: 'active',
                },
                ...getAccountsManageFilter(userState),
            ],
        },
    });
    if (filterData.occupationIds) {
        filter.push({
            column: 'occupationId',
            op: 'in',
            value: filterData.occupationIds,
        });
    }
    if (filterData.occupationGroup) {
        filter.push({
            column: 'occupationId',
            op: 'in',
            subFilter: {
                entity: occupationEntityName,
                filter: [
                    {
                        column: 'groupId',
                        op: '=',
                        value: filterData.occupationGroup,
                    },
                ],
            },
        });
    }
    if (filterData.credentialNames) {
        filter.push({
            column: 'credentialName',
            op: 'in',
            value: filterData.credentialNames,
        });
    }
    if (filterData.search) {
        filter.push({ column: 'search', op: 'full-text-query', value: filterData.search });
    }
    if (filterData.statuses) {
        filter.push({
            column: 'status',
            op: 'in',
            value: filterData.statuses,
        });
    }
    if (filterData.requestedBefore) {
        filter.push({
            column: 'requestDate',
            op: '<=',
            value: filterData.requestedBefore,
        });
    }
    if (filterData.requestedAfter) {
        filter.push({
            column: 'requestDate',
            op: '>=',
            value: filterData.requestedAfter,
        });
    }
    if (filterData.requestedBy) {
        filter.push({
            column: 'requestedBy',
            op: '=',
            value: filterData.requestedBy,
        });
    }
    if (filterData.jasBoard !== undefined) {
        filter.push({
            column: 'jasBoard',
            op: '=',
            value: filterData.jasBoard,
        });
    }
    if (filterData.credentialSearch) {
        filter.push({
            op: 'or',
            filter: [
                {
                    column: 'search',
                    op: 'full-text-query',
                    value: filterData.credentialSearch,
                },
                {
                    column: 'personId',
                    op: 'in',
                    subFilter: {
                        entity: accountEntityName,
                        filter: [{ column: 'partialSearch', op: 'contains', value: filterData.credentialSearch }],
                    },
                },
            ],
        });
    }
    if (expiringOnlyFilter === null || expiringOnlyFilter === void 0 ? void 0 : expiringOnlyFilter.length) {
        filter.push(...expiringOnlyFilter);
    }
    return filter;
}
